export enum GACategories {
    ReturnRequests = 'Return Requests',
    Products = 'Products',
    Payments = 'Payments',
    SpareParts = 'Spare Parts',
    UI = 'UI',
}
